import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_URL } from '../../api/api';
import Swal from 'sweetalert2';

function ChangePasswordLayer() {
  const token = localStorage.getItem('token');
  const [formData, setFormData] = useState({
    current_password: '',
    new_password: '',
    new_password_confirmation: ''
  });

  const [errors, setErrors] = useState({});
  const [showPassword, setShowPassword] = useState({
    current: false,
    new: false,
    confirm: false
  });
  const [isLoading, setIsLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [passwordStrength, setPasswordStrength] = useState({
    score: 0,
    message: '',
    color: '#6b7280'
  });

  // Inline styles object (same as before, but I'll keep it for completeness)
  const styles = {
    container: {
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #f9fafb 0%, #f3f4f6 100%)',
      padding: '3rem 1rem',
      fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif"
    },
    card: {
      maxWidth: '28rem',
      margin: '0 auto',
      backgroundColor: '#ffffff',
      borderRadius: '1rem',
      boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
      overflow: 'hidden'
    },
    cardContent: {
      padding: '2.5rem 2rem'
    },
    headerIcon: {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '4rem',
      height: '4rem',
      backgroundColor: '#dbeafe',
      borderRadius: '9999px',
      marginBottom: '1rem'
    },
    header: {
      textAlign: 'center',
      marginBottom: '2rem'
    },
    title: {
      fontSize: '17px !important',
      fontWeight: '700',
      color: '#111827',
      marginBottom: '0.5rem'
    },
    subtitle: {
      color: '#6b7280'
    },
    alert: {
      padding: '1rem',
      borderRadius: '0.5rem',
      marginBottom: '1.5rem',
      display: 'flex',
      alignItems: 'center'
    },
    alertSuccess: {
      backgroundColor: '#f0fdf4',
      border: '1px solid #bbf7d0'
    },
    alertError: {
      backgroundColor: '#fef2f2',
      border: '1px solid #fecaca'
    },
    alertTextSuccess: {
      color: '#166534'
    },
    alertTextError: {
      color: '#991b1b'
    },
    formGroup: {
      marginBottom: '1.5rem'
    },
    label: {
      display: 'block',
      fontSize: '0.875rem',
      fontWeight: '500',
      color: '#374151',
      marginBottom: '0.5rem'
    },
    inputWrapper: {
      position: 'relative'
    },
    input: {
      width: '100%',
      padding: '0.75rem 1rem',
      border: '1px solid #d1d5db',
      borderRadius: '0.5rem',
      fontSize: '0.875rem !important',
      transition: 'all 0.2s',
      outline: 'none'
    },
    inputFocus: {
      borderColor: '#3b82f6',
      boxShadow: '0 0 0 2px rgba(59, 130, 246, 0.2)'
    },
    inputError: {
      borderColor: '#f87171'
    },
    toggleButton: {
      position: 'absolute',
      right: '0.75rem !important',
      top: '50%',
      transform: 'translateY(-50%)',
      background: 'none',
      border: 'none',
      color: '#6b7280',
      cursor: 'pointer',
      padding: '0.25rem'
    },
    errorText: {
      marginTop: '0.5rem',
      fontSize: '0.75rem !important',
      color: '#dc2626',
      display: 'flex',
      alignItems: 'center'
    },
    strengthMeter: {
      marginTop: '0.75rem'
    },
    strengthHeader: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginBottom: '0.5rem'
    },
    strengthLabel: {
      fontSize: '0.75rem',
      fontWeight: '500'
    },
    strengthScore: {
      fontSize: '0.75rem',
      color: '#6b7280'
    },
    meterBar: {
      height: '0.5rem',
      backgroundColor: '#e5e7eb',
      borderRadius: '9999px',
      overflow: 'hidden'
    },
    meterFill: {
      height: '100%',
      borderRadius: '9999px',
      transition: 'width 0.3s ease'
    },
    requirements: {
      marginTop: '1rem'
    },
    requirementItem: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: '0.25rem'
    },
    requirementIcon: {
      width: '1rem',
      height: '1rem',
      marginRight: '0.5rem'
    },
    requirementText: {
      fontSize: '0.75rem'
    },
    submitButton: {
      width: '100%',
      background: 'linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%)',
      color: '#ffffff',
      fontWeight: '500',
      padding: '0.75rem 1rem',
      border: 'none',
      borderRadius: '0.5rem',
      cursor: 'pointer',
      fontSize: '0.875rem',
      transition: 'all 0.2s'
    },
    submitButtonHover: {
      background: 'linear-gradient(135deg, #1d4ed8 0%, #1e40af 100%)'
    },
    submitButtonDisabled: {
      opacity: '0.5',
      cursor: 'not-allowed'
    },
    tipsSection: {
      marginTop: '2.5rem',
      paddingTop: '1.5rem',
      borderTop: '1px solid #e5e7eb'
    },
    tipsTitle: {
      fontSize: '0.875rem',
      fontWeight: '600',
      color: '#111827',
      marginBottom: '0.75rem'
    },
    tipsList: {
      listStyle: 'none',
      padding: 0,
      margin: 0
    },
    tipItem: {
      display: 'flex',
      alignItems: 'flex-start',
      marginBottom: '0.5rem',
      fontSize: '0.875rem',
      color: '#6b7280'
    },
    tipDot: {
      width: '0.375rem',
      height: '0.375rem',
      backgroundColor: '#3b82f6',
      borderRadius: '50%',
      marginTop: '0.375rem',
      marginRight: '0.5rem',
      flexShrink: 0
    },
    loadingSpinner: {
      animation: 'spin 1s linear infinite',
      marginRight: '0.5rem'
    }
  };

  // Add keyframes for spinner animation
  useEffect(() => {
    const styleSheet = document.createElement('style');
    styleSheet.textContent = `
      @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
      }
    `;
    document.head.appendChild(styleSheet);

    return () => {
      document.head.removeChild(styleSheet);
    };
  }, []);

  const validatePassword = (password) => {
    const minLength = 8;
    const hasUpperCase = /[A-Z]/.test(password);
    const hasLowerCase = /[a-z]/.test(password);
    const hasNumbers = /\d/.test(password);
    const hasSpecialChar = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(password);

    let score = 0;
    let message = '';
    let color = '#6b7280';

    if (password.length >= minLength) score++;
    if (hasUpperCase) score++;
    if (hasLowerCase) score++;
    if (hasNumbers) score++;
    if (hasSpecialChar) score++;

    switch (score) {
      case 0:
        message = 'Very weak';
        color = '#ef4444';
        break;
      case 1:
      case 2:
        message = 'Weak';
        color = '#f87171';
        break;
      case 3:
        message = 'Moderate';
        color = '#eab308';
        break;
      case 4:
        message = 'Strong';
        color = '#4ade80';
        break;
      case 5:
        message = 'Very strong';
        color = '#16a34a';
        break;
      default:
        message = '';
    }

    return { score, message, color };
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.current_password.trim()) {
      newErrors.current_password = 'Current password is required';
    }

    if (!formData.new_password.trim()) {
      newErrors.new_password = 'New password is required';
    } else if (formData.new_password.length < 6) {
      newErrors.new_password = 'Password must be at least 6 characters';
    }

    if (!formData.new_password_confirmation.trim()) {
      newErrors.new_password_confirmation = 'Please confirm your password';
    } else if (formData.new_password !== formData.new_password_confirmation) {
      newErrors.new_password_confirmation = 'Passwords do not match';
    }

    if (formData.current_password === formData.new_password) {
      newErrors.new_password = 'New password must be different from current password';
    }

    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSuccessMessage('');
    setErrors({});

    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    setIsLoading(true);

    try {
      // Prepare the request data
      const requestData = {
        current_password: formData.current_password,
        new_password: formData.new_password,
        new_password_confirmation: formData.new_password_confirmation
      };

      // Make API call to change password
      const response = await axios.post(`${API_URL}/change-password`, requestData, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        }
      });

      if (response.data.message) {
        // Show success message with SweetAlert
        Swal.fire({
          icon: 'success',
          title: 'Success!',
          text: response.data.message || 'Password changed successfully!',
          timer: 3000,
          showConfirmButton: false,
          position: 'center'
        });

        // Reset form on success
        setFormData({
          current_password: '',
          new_password: '',
          new_password_confirmation: ''
        });
        setPasswordStrength({ score: 0, message: '', color: '#6b7280' });
        setSuccessMessage(response.data.message || 'Password changed successfully!');
      }

    } catch (error) {
      console.error('Password change error:', error);

      if (error.response) {
        // Server responded with an error status
        const { status, data } = error.response;

        if (status === 400 || status === 422) {
          // Validation errors from Laravel
          if (data.errors) {
            // Laravel validation errors format
            const validationErrors = {};
            Object.keys(data.errors).forEach(key => {
              validationErrors[key] = data.errors[key][0];
            });
            setErrors(validationErrors);
          } else if (data.message) {
            // Simple error message
            setErrors({ submit: data.message });

            // Show error with SweetAlert
            Swal.fire({
              icon: 'error',
              title: 'Error',
              text: data.message,
              confirmButtonColor: '#2563eb',
            });
          }
        } else if (status === 401) {
          // Unauthorized - token expired or invalid
          Swal.fire({
            icon: 'warning',
            title: 'Session Expired',
            text: 'Your session has expired. Please login again.',
            confirmButtonText: 'Login',
            allowOutsideClick: false
          }).then((result) => {
            if (result.isConfirmed) {
              localStorage.removeItem('token');
              window.location.href = '/login';
            }
          });
        } else {
          // Other server errors
          setErrors({ submit: 'Failed to change password. Please try again.' });
          Swal.fire({
            icon: 'error',
            title: 'Server Error',
            text: 'An unexpected error occurred. Please try again.',
            confirmButtonColor: '#2563eb',
          });
        }
      } else if (error.request) {
        // Request was made but no response
        setErrors({ submit: 'No response from server. Please check your connection.' });
        Swal.fire({
          icon: 'error',
          title: 'Connection Error',
          text: 'Unable to connect to the server. Please check your internet connection.',
          confirmButtonColor: '#2563eb',
        });
      } else {
        // Other errors
        setErrors({ submit: 'Failed to change password. Please try again.' });
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'An error occurred while changing password.',
          confirmButtonColor: '#2563eb',
        });
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    // Map the input names to match Laravel's expected field names
    const fieldName = name === 'currentPassword' ? 'current_password' :
      name === 'newPassword' ? 'new_password' :
        name === 'confirmPassword' ? 'new_password_confirmation' : name;

    setFormData(prev => ({
      ...prev,
      [fieldName]: value
    }));

    // Clear error for this field
    if (errors[fieldName]) {
      setErrors(prev => ({ ...prev, [fieldName]: '' }));
    }

    // Update password strength for new password
    if (fieldName === 'new_password') {
      setPasswordStrength(validatePassword(value));
    }
  };

  const togglePasswordVisibility = (field) => {
    setShowPassword(prev => ({
      ...prev,
      [field]: !prev[field]
    }));
  };

  const getPasswordRequirements = () => {
    return [
      { label: 'At least 6 characters', met: formData.new_password.length >= 6 },
      { label: 'Contains uppercase letter', met: /[A-Z]/.test(formData.new_password) },
      { label: 'Contains lowercase letter', met: /[a-z]/.test(formData.new_password) },
      { label: 'Contains number', met: /\d/.test(formData.new_password) },
      { label: 'Contains special character', met: /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(formData.new_password) }
    ];
  };

  // Helper function to render SVG icons
  const EyeIcon = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
      <circle cx="12" cy="12" r="3" />
    </svg>
  );

  const EyeOffIcon = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" />
      <line x1="1" y1="1" x2="23" y2="23" />
    </svg>
  );

  const CheckIcon = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3">
      <polyline points="20 6 9 17 4 12" />
    </svg>
  );

  const AlertIcon = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <circle cx="12" cy="12" r="10" />
      <line x1="12" y1="8" x2="12" y2="12" />
      <line x1="12" y1="16" x2="12.01" y2="16" />
    </svg>
  );

  const LockIcon = () => (
    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
      <path d="M7 11V7a5 5 0 0 1 10 0v4" />
    </svg>
  );

  const SpinnerIcon = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <circle cx="12" cy="12" r="10" strokeOpacity="0.25" />
      <path d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
    </svg>
  );

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.cardContent}>
          <div style={styles.header}>
            <div style={styles.headerIcon}>
              <LockIcon />
            </div>
            <h1 style={styles.title}>Change Password</h1>
            <p style={styles.subtitle}>Secure your account with a new password</p>
          </div>

          {successMessage && (
            <div style={{ ...styles.alert, ...styles.alertSuccess }}>
              <CheckIcon style={{ color: '#16a34a', marginRight: '0.75rem' }} />
              <span style={styles.alertTextSuccess}>{successMessage}</span>
            </div>
          )}

          {errors.submit && (
            <div style={{ ...styles.alert, ...styles.alertError }}>
              <AlertIcon style={{ color: '#dc2626', marginRight: '0.75rem' }} />
              <span style={styles.alertTextError}>{errors.submit}</span>
            </div>
          )}

          <form onSubmit={handleSubmit}>
            {/* Current Password */}
            <div style={styles.formGroup}>
              <label htmlFor="currentPassword" style={styles.label}>
                Current Password
              </label>
              <div style={styles.inputWrapper}>
                <input
                  type={showPassword.current ? "text" : "password"}
                  id="currentPassword"
                  name="currentPassword"
                  value={formData.current_password}
                  onChange={handleChange}
                  style={{
                    ...styles.input,
                    ...(errors.current_password ? styles.inputError : {}),
                    ':focus': styles.inputFocus
                  }}
                  placeholder="Enter current password"
                  disabled={isLoading}
                />
                <button
                  type="button"
                  onClick={() => togglePasswordVisibility('current')}
                  style={styles.toggleButton}
                  disabled={isLoading}
                >
                  {showPassword.current ? <EyeOffIcon /> : <EyeIcon />}
                </button>
              </div>
              {errors.current_password && (
                <p style={styles.errorText}>
                  <AlertIcon style={{ marginRight: '0.25rem' }} />
                  {errors.current_password}
                </p>
              )}
            </div>

            {/* New Password */}
            <div style={styles.formGroup}>
              <label htmlFor="newPassword" style={styles.label}>
                New Password
              </label>
              <div style={styles.inputWrapper}>
                <input
                  type={showPassword.new ? "text" : "password"}
                  id="newPassword"
                  name="newPassword"
                  value={formData.new_password}
                  onChange={handleChange}
                  style={{
                    ...styles.input,
                    ...(errors.new_password ? styles.inputError : {}),
                    ':focus': styles.inputFocus
                  }}
                  placeholder="Create new password"
                  disabled={isLoading}
                />
                <button
                  type="button"
                  onClick={() => togglePasswordVisibility('new')}
                  style={styles.toggleButton}
                  disabled={isLoading}
                >
                  {showPassword.new ? <EyeOffIcon /> : <EyeIcon />}
                </button>
              </div>

              {formData.new_password && (
                <div style={styles.strengthMeter}>
                  <div style={styles.strengthHeader}>
                    <span style={{ ...styles.strengthLabel, color: passwordStrength.color }}>
                      Password strength: {passwordStrength.message}
                    </span>
                    <span style={styles.strengthScore}>{passwordStrength.score}/5</span>
                  </div>
                  <div style={styles.meterBar}>
                    <div
                      style={{
                        ...styles.meterFill,
                        width: `${(passwordStrength.score / 5) * 100}%`,
                        backgroundColor: passwordStrength.color
                      }}
                    />
                  </div>

                  <div style={styles.requirements}>
                    {getPasswordRequirements().map((req, index) => (
                      <div key={index} style={styles.requirementItem}>
                        {req.met ? (
                          <CheckIcon style={{ ...styles.requirementIcon, color: '#16a34a' }} />
                        ) : (
                          <div style={{ ...styles.requirementIcon, borderRadius: '50%', border: '2px solid #d1d5db' }} />
                        )}
                        <span style={{
                          ...styles.requirementText,
                          color: req.met ? '#16a34a' : '#6b7280'
                        }}>
                          {req.label}
                        </span>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {errors.new_password && (
                <p style={styles.errorText}>
                  <AlertIcon style={{ marginRight: '0.25rem' }} />
                  {errors.new_password}
                </p>
              )}
            </div>

            {/* Confirm Password */}
            <div style={styles.formGroup}>
              <label htmlFor="confirmPassword" style={styles.label}>
                Confirm New Password
              </label>
              <div style={styles.inputWrapper}>
                <input
                  type={showPassword.confirm ? "text" : "password"}
                  id="confirmPassword"
                  name="confirmPassword"
                  value={formData.new_password_confirmation}
                  onChange={handleChange}
                  style={{
                    ...styles.input,
                    ...(errors.new_password_confirmation ? styles.inputError : {}),
                    ':focus': styles.inputFocus
                  }}
                  placeholder="Confirm new password"
                  disabled={isLoading}
                />
                <button
                  type="button"
                  onClick={() => togglePasswordVisibility('confirm')}
                  style={styles.toggleButton}
                  disabled={isLoading}
                >
                  {showPassword.confirm ? <EyeOffIcon /> : <EyeIcon />}
                </button>
              </div>
              {errors.new_password_confirmation && (
                <p style={styles.errorText}>
                  <AlertIcon style={{ marginRight: '0.25rem' }} />
                  {errors.new_password_confirmation}
                </p>
              )}
            </div>

            {/* Submit Button */}
            <div style={{ paddingTop: '1rem' }}>
              <button
                type="submit"
                disabled={isLoading}
                style={{
                  ...styles.submitButton,
                  ...(isLoading ? styles.submitButtonDisabled : {}),
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
                onMouseOver={(e) => {
                  if (!isLoading) {
                    e.currentTarget.style.background = styles.submitButtonHover.background;
                  }
                }}
                onMouseOut={(e) => {
                  if (!isLoading) {
                    e.currentTarget.style.background = styles.submitButton.background;
                  }
                }}
              >
                {isLoading ? (
                  <>
                    <SpinnerIcon style={styles.loadingSpinner} />
                    Changing Password...
                  </>
                ) : (
                  'Change Password'
                )}
              </button>
            </div>
          </form>

          {/* Tips Section */}
          <div style={styles.tipsSection}>
            <h4 style={styles.tipsTitle}>Password Tips</h4>
            <ul style={styles.tipsList}>
              <li style={styles.tipItem}>
                <div style={styles.tipDot} />
                Use a unique password for each account
              </li>
              <li style={styles.tipItem}>
                <div style={styles.tipDot} />
                Avoid using personal information
              </li>
              <li style={styles.tipItem}>
                <div style={styles.tipDot} />
                Consider using a password manager
              </li>
              <li style={styles.tipItem}>
                <div style={styles.tipDot} />
                Change your password regularly
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ChangePasswordLayer;